import { render } from "./homeUserCenter.vue?vue&type=template&id=3a7c6ccd&scoped=true"
import script from "./homeUserCenter.vue?vue&type=script&lang=js"
export * from "./homeUserCenter.vue?vue&type=script&lang=js"

import "./homeUserCenter.vue?vue&type=style&index=0&id=3a7c6ccd&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7c6ccd"]])

export default __exports__